import { render, staticRenderFns } from "./iconLink.vue?vue&type=template&id=0bc91464"
import script from "./iconLink.vue?vue&type=script&lang=js"
export * from "./iconLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports